export const ORIGINE_MISE_AU_PANIER = Object.freeze({
    INCONNU: 0,
    // OU
    FICHE_PRODUIT: 1,
    CATALOGUE_ACHAT_EXPRESS: 2,
    WISHLIST: 4,
    PANIER: 8,
    // COMMENT
    DIRECT: 16,
    ACHAT_EXPRESS: 32,
    CROSS_SELL: 64,
    // INTENTION CROSS SELL
    COMPLEMENT_DIRECT: 256,
    SECURITE_CONVERSION: 512,
    SAISONNIER: 1024,
    UPGRADE: 2048,
    ALTERNATIVE_PROCHE: 4096,
    ACCESSOIRE_IMPULSIF: 8192,
    AUTRE_INTENTION: 16384
})
